import { SearchResult } from '@backstage/plugin-search-react';
import { Box, Button } from '@backstage/ui';
import { RiArrowRightLine } from '@remixicon/react';

import styles from './SearchDropdown.module.css';
import { NoResultsComponent } from './NoResultComponent';
import { SearchResultItems } from './SearchResultItems';

type SearchDropDownProps = {
  onViewAll: () => void;
  onResultClick: () => void;
};

const maxResult = 5;

export const SearchDropDown = ({
  onViewAll,
  onResultClick,
}: SearchDropDownProps) => {
  return (
    <Box className={styles.dropdown}>
      <SearchResult noResultsComponent={<NoResultsComponent />}>
        {({ results }) => (
          <>
            <Box className={styles.results}>
              {results.slice(0, maxResult).map(result => (
                <SearchResultItems
                  key={`${result.type}-${result.rank}-${result.document.location ?? result.document.title}`}
                  result={result.document}
                  type={result.type}
                  rank={result.rank}
                  onClick={onResultClick}
                />
              ))}
            </Box>
            {results.length > maxResult && (
              <Box className={styles.actions}>
                <Button
                  variant="tertiary"
                  size="small"
                  className={styles.viewAllResults}
                  aria-label="viewallresults"
                  iconEnd={<RiArrowRightLine />}
                  onPress={onViewAll}
                >
                  View all results
                </Button>
              </Box>
            )}
          </>
        )}
      </SearchResult>
    </Box>
  );
};
